const state = {
  notifications: [],
  notificationCount: 0
};
const mutations = {
  FIRE_NOTIFICATION(state, notification) {
    state.notifications.unshift(notification);
    state.notificationCount++;
  },
  REMOVE_NOTIFICATION(state, matchedIndex) {
    state.notifications.splice(matchedIndex, 1);
  }
};
const actions = {
  fireNotification({ commit, state }, notification) {
    let id = state.notificationCount;
    id++;
    notification.id = id;
    commit("FIRE_NOTIFICATION", notification);
  },
  removeNotification({ commit }, index) {
    const matchedIndex = state.notifications.findIndex(
      notification => notification.id === index
    );
    commit("REMOVE_NOTIFICATION", matchedIndex);
  }
};
const getters = {
  notifications: state => state.notifications
};

const notificationsModule = {
  state,
  mutations,
  actions,
  getters
};

export default notificationsModule;
